<template>
  <div>
    <el-table :data="campaigns" style="width: 100%">
      <el-table-column fixed label="" width="100">
        <template slot-scope="scope">
          <CampaignsOverviewCampaignsTableStatus
            :campaign="scope.row"
            :status="scope.row.status === 'ACTIVE'"
            :id="scope.row.id"
            @updateStatus="updateStatus"
          />
        </template>
      </el-table-column>
      <el-table-column fixed prop="name" label="Campaign Name" width="200" />
      <el-table-column label="Campaign Goal" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.adlabels">
            {{
            scope.row.adlabels[0]
            ? scope.row.adlabels[0].name.substring(3)
            : ''
            }}
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column label="Actions" width="100">
        <template slot-scope="scope">
          <CampaignOverviewCampaignsTableQuickActions :campaign="scope.row" @openDialog="openDialog" />
        </template>
      </el-table-column>
      <el-table-column prop="effective_status" label="Status" width="150" />
      <el-table-column
        v-for="(insight, index) in insightNames"
        :key="index"
        :label="insight.name"
        width="150"
      >
        <template slot-scope="scope">
          <td>
            {{ insights[scope.row.id]
            ? insights[scope.row.id][0][insight.value]
              ? insights[scope.row.id][0][insight.value] : '-'
            : '-'}}</td>
        </template>
      </el-table-column>
    </el-table>
    <confirmation-dialog
      :text="popUpText"
      :archivedCampaignId="archivedCampaignId"
      :dialog="dialog"
      @closeDialog="closeDialog"
      @archiveCampaign="updateStatus"
    />
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import lodash from 'lodash'
  import helpers from '../../../helpers/functions'
  import moment from 'moment'
  import ConfirmationDialog from '../../helpers/ConfirmationDialog'
  import CampaignsOverviewCampaignsTableStatus from './CampaignsOverviewCampaignsTableStatus'
  import CampaignOverviewCampaignsTableQuickActions from './CampaignOverviewCampaignsTableQuickActions'

  export default {
    name: 'campaigns-overview-campaigns-table',
    components: {
      ConfirmationDialog,
      CampaignsOverviewCampaignsTableStatus,
      CampaignOverviewCampaignsTableQuickActions
    },
    data () {
      return {
        sortBy: 'insights.spend',
        descending: true,
        headers: [
          {text: '', align: 'center', value: 'switch', width: '20px', sortable: false},
          {text: 'Campaign name', align: 'left', value: 'name'},
          {text: 'Campaign type', align: 'left', value: 'adlabels'},
          {text: 'Quick Actions', align: 'center', value: 'edit', width: '20px', sortable: false},
          {text: 'Status', align: 'left', value: 'effective_status'},
          {text: 'Budget Spent', align: 'right', value: 'insights.spend'},
          {text: 'Reach', align: 'right', value: 'insights.reach'},
          {text: 'Actions', align: 'right', value: 'insights.total_actions'},
          {text: 'Cost per Action', align: 'right', value: 'insights.cost_per_total_action'},
          {text: 'Clicks', align: 'right', value: 'insights.clicks'},
          {text: 'Cost per Click', align: 'right', value: 'insights.cpc'},
          {text: 'Impressions', align: 'right', value: 'insights.impressions'},
          {text: 'CPM', align: 'right', value: 'insights.cpm'},
          {text: 'CTR', align: 'right', value: 'insights.ctr'}
        ],
        doubleClick: false,
        popUpText: null,
        archivedCampaignId: null,
        dialog: false,
        insightNames: [
          {
            name: 'Spend',
            value: 'spend'
          },
          {
            name: 'Reach',
            value: 'reach'
          },
          {
            name: 'Total Actions',
            value: 'total_actions'
          },
          {
            name: 'CTA',
            value: 'cost_per_total_action'
          },
          {
            name: 'Click',
            value: 'clicks'
          },
          {
            name: 'CPC',
            value: 'cpc'
          },
          {
            name: 'Impressions',
            value: 'impressions'
          },
          {
            name: 'CMP',
            value: 'cmp'
          },
          {
            name: 'CTR',
            value: 'ctr'
          }
        ]
      }
    },
    props: {
      campaigns: {
        type: Array,
        default: () => []
      },
      search: {
        type: String,
        default: ''
      }
    },
    computed: {
      spinner () {
        return this.$store.getters.getSpinner
      },
      allCampaigns () {
        return this.$store.getters.getCampaigns
      },
      reportingDates () {
        return this.$store.getters.getReportingDates
      },
      insights () {
        const insights = this.$store.getters.getCampaignsInsights
        // return insights.filter(insight => this.campaigns.find(campaign => campaign.id === insight.campaign_id))
        return lodash.groupBy(insights, 'campaign_id')
      },
      total () {
        if (!this.insights.length) return false
        return helpers.countTotal(this.insights)
      },
      updatedCampaigns () {
        // Note: added insights for each campaign
        let copy = lodash.cloneDeep(this.campaigns)
        copy.forEach(campaign => {
          if (campaign.adlabels) campaign.adlabels = campaign.adlabels.map(a => a.name).join(' ')
          const insights = this.getInsights(campaign.id)
          if (insights) {
            campaign.insights = insights
          } else {
            campaign.insights = {}
          }
        })
        return copy
      }
    },
    filters: {
      titleCase (str) {
        if (!str) return ''
        return str.replace(
          /\w\S*/g,
          function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
          }
        )
      },
      moneyFormat (number) {
        if (isNaN(number)) return ''
        return Number(number).toFixed(2).toString().toLocaleString()
      },
      thousands: function (number) {
        return Number(number).toLocaleString()
      },
      currency: function (number) {
        return '$' + parseFloat(number).toFixed(2)
      },
      percent: function (number) {
        return parseFloat(number).toFixed(1) + '%'
      }
    },
    methods: {
      openDialog (campaign) {
        this.popUpText = `Are you sure you want to archive ${campaign.name}?`
        this.archivedCampaignId = campaign.id
        this.dialog = true
      },
      closeDialog () {
        this.popUpText = null
        this.archivedCampaignId = null
        this.dialog = false
      },
      getStatus (status) {
        return status === 'ACTIVE'
      },
      getInsights (id) {
        const insights = this.insights.find(i => i.campaign_id === id)
        if (insights) return insights
        return false
      },
      updateStatus (id, archive) {
        // Note: clone from vuex because adlabels must be array
        const newCampaign = lodash.cloneDeep(this.allCampaigns.find(c => c.id === id))
        if (archive) {
          newCampaign.status = 'ARCHIVED'
          this.closeDialog()
        } else if (newCampaign.effective_status === 'ACTIVE') {
          newCampaign.effective_status = 'PAUSED'
        } else {
          newCampaign.effective_status = 'ACTIVE'
        }
        new Promise(resolve => {
          resolve(this.editCampaign(newCampaign))
        })
          .then(() => {
            if (archive) {
              this.$store.dispatch('showNotification', {
                type: 'success',
                message: [`You successfully archived ${newCampaign.name}`]
              })
            }
            console.log('Status updated')
          })
      },
      copyCampaign (campaign) {
        const copy = lodash.cloneDeep(campaign)
        const payload = {
          start_time: moment(copy.start_time).format('YYYY-MM-DD hh:mm:ss'),
          end_time: moment().add(1, 'days').format('YYYY-MM-DD hh:mm:ss'),
          daily_budget: copy.daily_budget,
          lifetime_budget: copy.lifetime_budget,
          selectedBudget: copy.daily_budget ? 'daily_budget' : 'lifetime_budget',
          name: `${copy.name} - Copy`,
          objective: copy.objective,
          status: 'PAUSED',
          type: copy.adlabels,
          issues: copy.issues,
          messages: copy.messages,
          targeting: copy.targeting
        }
        this.createCampaign(payload)
      },
      ...mapActions([
        'createCampaign',
        'editCampaign'
      ])
    }
  }
</script>
